import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app/App";
import { AppErrorBoundary } from "./app/components/AppErrorBoundary";
import { recordAppOpened } from "./infrastructure/firebase/telemetry";
import "./styles/global.css";

const root = document.getElementById("root");
if (!root) throw new Error("The LogBookAnaes Studio root element is missing.");

const demoMode = window.location.pathname === "/demo"
  || window.location.pathname.startsWith("/demo/");

// Sample mode deliberately avoids Firebase initialisation so it cannot restore
// an account session or create persistent Auth/Firestore browser storage.
if (!demoMode) void recordAppOpened();

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <BrowserRouter {...(demoMode ? { basename: "/demo" } : {})}>
        <App demoMode={demoMode} />
      </BrowserRouter>
    </AppErrorBoundary>
  </StrictMode>,
);
